export function groupBy<T, TKey>(array: T[], getKey: (item: T) => TKey): Map<TKey, T[]> {
  return array.reduce((result, item) => {
    const key = getKey(item);
    if (!result.has(key)) {
      result.set(key, []);
    }
    result.get(key)!.push(item);
    return result;
  }, new Map<TKey, T[]>());
}
